import { useBoolean } from "@fluentui/react-hooks";
import React, { useState, useEffect } from "react";
import { baseUrl } from "../../helpers/constants";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import i18n from "i18next";
import { helperMethods } from "../../helpers/helperMethods";
import i18next from "i18next";
import useWindowSize from "../../helpers/useWindowSize";
import {
  Checkbox,
  Dropdown,
  Option,
  Label,
  Radio,
  RadioGroup,
  Field,
  Input,
  Tooltip,
  DataGrid,
  DataGridHeader,
  DataGridRow,
  DataGridHeaderCell,
  DataGridBody,
  DataGridCell,
} from "@fluentui/react-components";
import { InfoRegular } from "@fluentui/react-icons";
import { ILuebOption } from "../../Models/ILuebOption";
import SelectionServiceColumns from "./SelectionServiceColumns";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";

interface IServiceSelectionProps {
  configurationParameter: any;
  onSelectionChanged: any;
}

function ServiceSelection(props: IServiceSelectionProps) {
  const windowSize = useWindowSize();
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [mfus, setMfus] = useState<any[]>([]);
  const [runningInServices, setRunningInServices] = useState<any[]>([]);

  const [selectedMfu, setSelectedMfu] = useState<any>(undefined);
  const [selectedRunningIn, setSelectedRunningIn] = useState<any>(undefined);

  const [pruefDrehMoment, setPruefDrehMoment] = useState(
    props.configurationParameter.anzugsmoment
  );

  const [laserBeschriftung, setLaserBeschriftung] = useState("");

  const [trimmen, setTrimmen] = useState(false);

  const [toolAssembly, setToolAssembly] = useState(true);
  const [mountingDirection, setMountingDirection] = useState("middle");

  const [directionOfRotation, setDirectionOfRotation] = useState("right");
  const directionOfRotationOptions: ILuebOption[] = [
    {
      key: "right",
      text: i18n.t<string>("right"),
    },
    {
      key: "left",
      text: i18n.t<string>("left"),
    },

    {
      key: "both",
      text: i18n.t<string>("leftAndRight"),
    },
  ];

  const [mountingAngle, setMountingAngle] = useState<any>(undefined);

  const mountingDirectionOptions: ILuebOption[] = [
    { key: "middle", text: i18n.t<string>("middle") },
    { key: "left", text: i18n.t<string>("left") },
    { key: "right", text: i18n.t<string>("right") },
  ];

  const [
    adaptionsWinkelBubbleVisible,
    { toggle: toggleAdaptionsWinkelBubble },
  ] = useBoolean(false);

  const getMachineCapabilityTest = () => {
    if (props.configurationParameter.tool) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/Configurator/GetMachineCapabilityTest?antrieb=${props.configurationParameter.tool.energie}`
        )
        .then((result: ILSP3ResponseDto[]) => {
          setMfus(result);
        });
    } else {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/Configurator/GetMachineCapabilityTest?antrieb=ohne`
        )
        .then((result: ILSP3ResponseDto[]) => {
          setMfus(result);
        });
    }
  };

  const getRunningInService = () => {
    if (props.configurationParameter.tool) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/Configurator/GetRunningInService?antrieb=${props.configurationParameter.tool.energie}`
        )
        .then((result: any[]) => {
          result = result.map((runin: any) => {
            runin.key = runin.artikelId;
            return runin;
          });
          setRunningInServices(result);
        });
    } else {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/Configurator/GetRunningInService?antrieb=ohne`
        )
        .then((result: any[]) => {
          result = result.map((runin: any) => {
            runin.key = runin.artikelId;
            return runin;
          });
          setRunningInServices(result);
        });
    }
  };

  useEffect(() => {
    getMachineCapabilityTest();
  }, []);

  useEffect(() => {
    getRunningInService();
  }, [selectedMfu]);

  /* const getSelectedMfu = () => {
    const selectedItem = selectionMfu.getSelection();
    if (selectedItem.length == 1) {
      const item = selectedItem[0];
      setSelectedMfu(item);
    } else {
      setSelectedMfu(undefined);
    }
  }; */

  const nmConverter = () => {
    const nm = helperMethods.convertToNumber(pruefDrehMoment.nm);
    setPruefDrehMoment({
      nm: helperMethods.nachkomma(nm, 2),
      inlbs: helperMethods.nachkomma(nm * 8.8507457676, 2),
    });
  };

  const lbsInConverter = () => {
    const inlbs = helperMethods.convertToNumber(pruefDrehMoment.inlbs);
    setPruefDrehMoment({
      inlbs: inlbs,
      nm: inlbs * 0.11298482933333,
    });
  };

  useEffect(() => {
    updateConfiguration();
  }, [
    selectedMfu,
    selectedRunningIn,
    pruefDrehMoment,
    laserBeschriftung,
    directionOfRotation,
    mountingDirection,
    mountingAngle,
    toolAssembly,
    trimmen,
  ]);

  const updateConfiguration = () => {
    const returnValue = {
      selectedMfu: selectedMfu?.artikelId,
      selectedRunningIn: selectedRunningIn?.artikelId,
      pruefDrehMoment: pruefDrehMoment.nm,
      laserBeschriftung: laserBeschriftung,
      directionOfRotation: directionOfRotation,
      mountingDirection: mountingDirection,
      mountingAngle: mountingAngle,
      toolAssembly: toolAssembly,
      trimmen: trimmen,
    };
    props.onSelectionChanged(returnValue);
  };

  const columns1 = SelectionServiceColumns();
  const columns2 = SelectionServiceColumns();

  return (
    <div>
      <h6 style={{ fontWeight: 700, marginTop: "10px" }}>
        {i18n.t<string>("selectionMfu")}
      </h6>

      <DataGrid
        selectionMode="single"
        selectedItems={
          selectedMfu ? new Set([mfus.indexOf(selectedMfu)]) : new Set([])
        }
        onSelectionChange={(ev, data) => {
          const selItem = data.selectedItems;
          mfus.forEach((obj, index) => {
            if (selItem.has(index)) {
              setSelectedMfu(obj);
            }
          });
        }}
        columns={columns1.columns}
        items={mfus}
        resizableColumns
        columnSizingOptions={{
          checkedId: { defaultWidth: 50, minWidth: 50 },
          benennungM1: { defaultWidth: 150, minWidth: 130 },
          artikelId: { defaultWidth: 80, minWidth: 80 },
        }}
      >
        <DataGridHeader>
          <DataGridRow>
            {({ renderHeaderCell }) => (
              <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
            )}
          </DataGridRow>
        </DataGridHeader>
        <DataGridBody<ILSP3ResponseDto>>
          {({ item, rowId }) => (
            <DataGridRow<ILSP3ResponseDto>
              key={rowId}
              /* onMouseEnter={() => {
                setHover(item.id);
              }}
              onMouseLeave={() => {
                setHover("");
              }} */
            >
              {({ renderCell }) => (
                <DataGridCell>{renderCell(item)}</DataGridCell>
              )}
            </DataGridRow>
          )}
        </DataGridBody>
      </DataGrid>

      <Checkbox
        checked={!selectedMfu}
        label={i18n.t<string>("withoutMfu")}
        onChange={(ev, data) => {
          if (data.checked == true) {
            setSelectedMfu(undefined);
          }
        }}
      />

      <h6 style={{ fontWeight: 700, marginTop: "10px" }}>
        {i18n.t<string>("selectionRunningIn")}
      </h6>
      <DataGrid
        selectionMode="single"
        selectedItems={
          selectedRunningIn
            ? new Set([runningInServices.indexOf(selectedRunningIn)])
            : new Set([])
        }
        onSelectionChange={(ev, data) => {
          const selItem = data.selectedItems;
          runningInServices.forEach((obj, index) => {
            if (selItem.has(index)) {
              if (selectedRunningIn != obj) {
                setSelectedRunningIn(obj);
              } else {
                setSelectedRunningIn(undefined);
              }
            }
          });
        }}
        columns={columns2.columns}
        items={runningInServices}
        resizableColumns
        columnSizingOptions={{
          checkedId: { defaultWidth: 50, minWidth: 50 },
          benennungM1: { defaultWidth: 150, minWidth: 130 },
          artikelId: { defaultWidth: 80, minWidth: 80 },
        }}
      >
        <DataGridHeader>
          <DataGridRow>
            {({ renderHeaderCell }) => (
              <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
            )}
          </DataGridRow>
        </DataGridHeader>
        <DataGridBody<ILSP3ResponseDto>>
          {({ item, rowId }) => (
            <DataGridRow<ILSP3ResponseDto> key={rowId}>
              {({ renderCell }) => (
                <DataGridCell>{renderCell(item)}</DataGridCell>
              )}
            </DataGridRow>
          )}
        </DataGridBody>
      </DataGrid>

      <h6 style={{ fontWeight: 700, marginTop: "10px" }}>
        {i18n.t<string>("details")}
      </h6>

      <Label>{i18n.t<string>("directionOfRotation")}</Label>
      <RadioGroup value={directionOfRotation}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          {directionOfRotationOptions.map((item) => {
            return (
              <Radio
                checked={item.key == directionOfRotation}
                onChange={(ev, data) => {
                  if (data.value == "on") {
                    setDirectionOfRotation(
                      typeof item.key == "string" ? item.key : ""
                    );
                  }
                }}
                key={item.key}
                label={item.text}
              />
            );
          })}
        </div>
      </RadioGroup>

      <Label className="lueb-MarginTop10">
        {i18n.t<string>("pruefDrehmoment")}
      </Label>
      <div className="lueb-WrapContainer200">
        <Field>
          <Input
            contentBefore="Nm"
            inputMode="numeric"
            onBlur={nmConverter}
            value={pruefDrehMoment.nm.toLocaleString(undefined, {
              maximumFractionDigits: 3,
            })}
            onKeyDown={(e: any) => {
              if (e.key == "Enter") {
                nmConverter();
              }
            }}
            onChange={(ev, val) => {
              setPruefDrehMoment({
                nm: val.value,
                inlbs: pruefDrehMoment.inlbs,
              });
            }}
          />
        </Field>
        <Field>
          <Input
            contentBefore="in.lbs"
            inputMode="decimal"
            onBlur={lbsInConverter}
            value={pruefDrehMoment.inlbs.toLocaleString(undefined, {
              maximumFractionDigits: 3,
            })}
            onKeyDown={(e: any) => {
              if (e.key == "Enter") {
                lbsInConverter();
              }
            }}
            onChange={(ev, val) => {
              setPruefDrehMoment({
                inlbs: val.value,
                nm: pruefDrehMoment.nm,
              });
            }}
          />
        </Field>
      </div>

      {["Standard_FL_O", "Inline_FL_O"].includes(
        props.configurationParameter.gearbox.key
      ) && (
        <>
          <h6 style={{ fontWeight: 700, marginTop: "10px" }}>
            {i18n.t<string>("trimmen")}
          </h6>
          <Checkbox
            checked={trimmen}
            onChange={(ev, data) => {
              if (data.checked != "mixed") {
                setTrimmen(data.checked);
              }
            }}
            label={i18n.t<string>("trimmen")}
          />
        </>
      )}

      <h6 style={{ fontWeight: 700, marginTop: "10px" }}>
        {i18n.t<string>("toolAssembly")}
      </h6>
      <Checkbox
        checked={toolAssembly}
        onChange={(ev, data) => {
          if (data.checked == false) {
            setMountingAngle(undefined);
          }
          if (data.checked != "mixed") {
            setToolAssembly(data.checked);
          }
        }}
        label={i18n.t<string>("toolAssembly")}
      />

      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            marginRight: "5px",
          }}
        >
          <Label>{i18n.t<string>("mountingDirection")}</Label>
          <Field>
            <Dropdown
              open={dropdownOpen}
              onClick={() => {
                if (toolAssembly == true) {
                  setDropdownOpen(true);
                }
              }}
              appearance={toolAssembly ? undefined : "filled-darker"}
              selectedOptions={[mountingDirection]}
              value={
                toolAssembly == true
                  ? mountingDirectionOptions.find(
                      (x) => x.key == mountingDirection
                    )?.text
                  : ""
              }
              onOptionSelect={(ev, val) => {
                if (val.optionValue) {
                  setMountingDirection(val.optionValue);
                }
                setDropdownOpen(false);
              }}
            >
              {mountingDirectionOptions.map((item) => {
                if (typeof item.key == "string") {
                  return <Option value={item.key}>{item.text}</Option>;
                }
              })}
            </Dropdown>
          </Field>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          <Label>
            <Label>{i18n.t<string>("mountingAngle")}</Label>
            <Tooltip
              content={i18n.t<string>("adaptionswinkelHint")}
              relationship={"label"}
            >
              <InfoRegular style={{ marginLeft: "5px", marginBottom: "2px" }} />
            </Tooltip>
          </Label>
          <Field>
            <Input
              appearance={
                mountingDirection == "middle" || !toolAssembly
                  ? "filled-darker"
                  : undefined
              }
              readOnly={mountingDirection == "middle" || !toolAssembly}
              inputMode="decimal"
              type="number"
              contentAfter={"° " + i18n.t<string>("degree")}
              value={
                toolAssembly == true &&
                mountingDirection != "middle" &&
                mountingAngle >= 0
                  ? mountingAngle
                  : "0"
              }
              onChange={(ev, data) => {
                if (Number(data.value) >= 0) {
                  setMountingAngle(data.value);
                }
              }}
            />
          </Field>
        </div>
      </div>

      <div
        style={{
          marginTop: 10,
          marginBottom: 20,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Label>{i18n.t<string>("sonderbeschriftung")}</Label>
        <Input
          value={laserBeschriftung}
          onChange={(ev, data) => setLaserBeschriftung(data.value)}
        />
      </div>
    </div>
  );
}

export default ServiceSelection;
